import { render, staticRenderFns } from "./CourseTreeNode.vue?vue&type=template&id=290a101d&scoped=true"
import script from "./CourseTreeNode.vue?vue&type=script&lang=js"
export * from "./CourseTreeNode.vue?vue&type=script&lang=js"
import style0 from "./CourseTreeNode.vue?vue&type=style&index=0&id=290a101d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290a101d",
  null
  
)

export default component.exports